<app-tabla
  [totalCount]="totalCount"
  [datos]="datos"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [filtros]="filtros"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [showHijos]="true"
  [emptyState]="{ title: 'Todavía no hay configuraciones de notificación' }"
></app-tabla>
